import React, { Component, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
 
const LoyaltyPopup = (props) => {
return (
  <Modal {...props} className="loyalty-popup" aria-labelledby="contained-modal-title-vcenter" centered>
    <section className='loyalty-modal'>
      <a onClick={props.loyalty_closeBtn} className='close-icon' href='javascript:;' title='Close'>&nbsp;</a>
      <Modal.Body>
        <h1>LOYALTY ACCOUNT</h1>  
        <p>Your rewards number is registered with rewards account as follows. Please choose to proceed with</p>
        <section className='mmr-list'>
          <ul>
            {
              props.state.loyaltyAPI != '' &&
                props.state.loyaltyAPI.data.map((loyaltyData, Lindex) => {
                  return(
                    <li kay={Lindex}>
                      <aside className="form-group">
                        <input onChange={(e) => props.loyaltyPopupOnchange(e, Lindex, loyaltyData)} type="radio" name="mmr-input" id={`mmr-${Lindex}`} />
                        <label for={`mmr-${Lindex}`}>
                          <p>{loyaltyData.membershipId}</p><span className="radio-btn">&nbsp;</span>
                        </label>
                      </aside>
                    </li>
                  )
                })
            }
          </ul>
        </section>
        {
          props.state.okBtnSH &&
          <aside className="cmx-flex-btn-group text-start pt-4">
            <a onClick={props.loyaltyOkBtn} className="flex-btn" href="javascript:;" title="OK"><span>OK</span></a>
          </aside>
        }
        
      </Modal.Body>
    </section>
  </Modal>
)}
export default LoyaltyPopup;